import {Component, OnInit, Input} from '@angular/core';

import {Offer} from '../../../../models/Offer';
import {OffersService} from '../../../../services/offers/offers.service';
import {User} from '../../../../models/User';

@Component({
  selector: 'app-print-offer',
  templateUrl: './print-offer.component.html',
  styleUrls: ['./print-offer.component.scss']
})
export class PrintOfferComponent implements OnInit {
  
  @Input() selectedOffer: Offer;
  @Input() selectedPictureIndex: number;
  @Input() selectedCurrency: string;
  @Input() selectedUser: User;
  
  offerType: string;
  noImageAvailableUrl = 'src/assets/images/no-images-available.jpg';
  
  constructor(public offersService: OffersService) {
  }
  
  ngOnInit() {
    if (this.selectedOffer.isSellable) {
      this.offerType = 'SELLABLE';
    } else if (this.selectedOffer.isRentable) {
      this.offerType = 'RENTABLE';
    }
  }
  
}
